export const postMessage = (requestReason, value) => {
  if (!requestReason) {
    return;
  }
  const requestObj = {
    type: 'games',
    value: value || '',
    requestReason,
  };
  const requestStr = JSON.stringify(requestObj);
  if (
    navigator &&
    navigator.userAgent &&
    (navigator.userAgent.includes('iPhone') ||
      navigator.userAgent.includes('iPad'))
  ) {
    if (
      typeof window !== 'undefined' &&
      typeof window.webkit !== 'undefined' &&
      typeof window.webkit.messageHandlers !== 'undefined' &&
      typeof window.webkit.messageHandlers.tilAppWebBridge !== 'undefined' &&
      typeof window.webkit.messageHandlers.tilAppWebBridge.postMessage ===
        'function'
    ) {
      window.webkit.messageHandlers.tilAppWebBridge.postMessage(requestStr);
    }
  } else if (
    typeof window !== 'undefined' &&
    typeof window.tilAppWebBridge !== 'undefined' &&
    typeof window.tilAppWebBridge.postMessage === 'function'
  ) {
    window.tilAppWebBridge.postMessage(requestStr);
  }
};

// Helper function to calculate distance using Haversine formula
export const calculateHaversineDistance = (coord1, coord2) => {
  const toRad = angle => Math.PI / 180 * angle;
  const R = 6371; // Earth radius in kilometers
  const dLat = toRad(coord2.lat - coord1.lat);
  const dLon = toRad(coord2.lng - coord1.lng);
  const lat1 = toRad(coord1.lat);
  const lat2 = toRad(coord2.lat);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

// export const hasNewTilBridge = () => {
//   if (
//     typeof window !== 'undefined' &&
//     typeof window.webkit !== 'undefined' &&
//     typeof window.webkit.messageHandlers !== 'undefined' &&
//     typeof window.webkit.messageHandlers.tilAppWebBridge !== 'undefined'
//   ) {
//     return true;
//   } else if (
//     typeof window !== 'undefined' &&
//     typeof window.tilAppWebBridge !== 'undefined'
//   ) {
//     return true;
//   }
//   return false;
// };

export default postMessage;
